import { DatesToMoveIn } from '../graphql/generated';

export const datesToMoveInMap: Record<DatesToMoveIn, string> = {
  AS_SOON_AS_POSSIBLE: 'As soon as possible',
  ONE_TO_TWO_MONTHS: 'in 1-2 months',
  THREE_TO_FOUR_MONTHS: 'in 2-3 months',
  FOUR_MONTHS_PLUS: 'in 4 months+',
  NOT_SURE_YET: 'Not sure yet',
};
